import React from 'react';
import { Navigate, useParams, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { WebLogin as doWebLogin } from '../store/actions/webLoginAction';
import { set_filters } from '../store/actions/action';
import { CircularProgress, Grid } from '@material-ui/core';

function WebLogin() {
  const dispatch = useDispatch();
  const { store_id, location_id, page } = useParams();
  const [redirect, setRedirect] = React.useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const is_fsr = useSelector((state) => state.sessionReducer?.is_fsr);
  const tent_id = useSelector((state) => state.sessionReducer?.tent_id);
  const associated_stores = useSelector((state) => state.sessionReducer?.associated_stores);

  const queryParams = new URLSearchParams(location.search);
  const filter = queryParams.get('filter');
  if (filter) {
    const filterObject = filter.split(',').reduce((acc, pair) => {
      const [key, value] = pair.split(':');
      if (key && value) acc[key] = value;
      return acc;
    }, {});
    dispatch(set_filters(filterObject));
  }

  const getLogin = async () => {
    const success = await dispatch(doWebLogin({ store_id, location_id }));
    setRedirect(success);
  };

  React.useEffect(() => {
    if (redirect === null) {
      getLogin();
    } else if (redirect === false) {
      navigate('/store-close');
    }
  }, [redirect]); // eslint-disable-line react-hooks/exhaustive-deps

  const PolicyPage = (pg) => {
    const privatepages = [
      'privacy-policy',
      'terms-condition',
      'shipping-policy',
      'refund-policy',
      'contactus',
      'registration-form',
      'aahar-registration-form',
      'aboutus',
    ];
    if (privatepages.includes(pg)) return <Navigate to={'/' + pg} />;
    return <Navigate to="/" />;
  };

  const hasAssociated = Array.isArray(associated_stores) && associated_stores.length > 0;
  const initialTarget = (is_fsr || tent_id) ? (hasAssociated ? "/stores" : "/menu") : "/";

  return redirect ? (
    page ? PolicyPage(page) : <Navigate to={initialTarget} />
  ) : (
    <Grid className="loadingreport" style={{ paddingTop: '20rem' }}>
      <CircularProgress variant="indeterminate" />
      <p>Loading</p>
    </Grid>
  );
}

export default WebLogin;
